import clsx from 'clsx';
import React from "react";
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import I18n from "../../base/i18n.js";
import Routes from "../routes.js";

import FooterBackground from "./footer_background.svg";
import XavinLogo from "./xavin.svg"

const blockStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.DarkBlue,
    backgroundImage: `url(${FooterBackground})`,
    backgroundSize: "110px",
    fontFamily: theme.typography.fontFamily
  },
  content: {
    display: "flex",
    flexDirection: "column",
    padding: "45px 16px 10px",
    justifyContent: "space-between",
    ['@media (max-width: 768px)']: {
      padding: "48px 24px",
    },
  },
  row: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap"

  },
  logo: {
    marginRight: "20rem",
    marginBottom: "-3rem",
    display: "block",
    ['@media (max-width: 992px)']: {
      display: "none",
    },
  },
  link: {
    cursor: "pointer",
    // marginTop: "10px",
    display: "block",
    // fontSize: "18px",
    fontWeight: theme.typography.fontWeightRegular,
    // lineHeight: "29px",
    color: theme.palette.white,
    textDecoration: "none",
    '&:hover': {
      textDecoration: "underline",
    },
    // margin: "0 16px 14px",

    ['@media (max-width: 768px)']: {
      textAlign: "center",
      // fontSize: "16px",
      // lineHeight: "20px",
    },
  },
  smallLink: {
    fontSize: "12px",
    lineHeight: "22px",
    margin: "0 7px"
  },
  textSm: {

  },
  linkGroup: {
    alignItems: "baseline",
    ['@media (max-width: 768px)']: {
      flexDirection: "column",
      alignItems: "center"
    },
  },
  copyright: {
    fontWeight: theme.typography.fontWeightLight,
    color: theme.palette.white,
    fontSize: "12px",
    lineHeight: "22px",
    margin: "0 7px"
  },
  footerTitle: {
    marginBottom: "0.5rem",
    fontWeight: "700",
    textTransform: "uppercase",
    opacity: "0.5"
  },
  footerWrapper: {
    color: theme.palette.white
  },
  footer: {
    display: "grid",
    placeItems: "start",
    rowGap: "2.5rem",
    columnGap: "1rem",
    backgroundImage: "none",
    padding: "2.5rem",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "72rem",
    display: "grid",
    gridAutoFlow: "column",
    fontSize: "0.875rem",
    lineHeight: "1.25rem"
  },
  footerColumn: {
    display: "grid",
    placeItems: "start",
    gap: "0.5rem"
  },
  footerRow: {

  },
  itemsCenter: {
    alignItems: "center"
  },
  gridFlowCol: {
    gridAutoFlow: "column"
  },
  grid: {
    display: "grid"
  },
  Gap4: {
    gap: "1rem"
  },
  text2xl: {
    fontSize: "1.5rem",
    lineHeight: "2rem"
  },
  brand: {
    color: theme.palette.white
  },
  placeSelfCenter: {
    placeSelf: "center"
  },
  justifySelfEnd: {
    justifySelf: "end"
  },
  contentLg: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "72rem"
  },
  borderT: {
    borderWidth: "0",
    borderTopWidth: "1px"
  },
  borderBase200: {
    boxSizing: "border-box",
    borderStyle: "solid",
    borderColor: "#e5e7eb"
  },
  opacity10: {
    opacity: "0.1"
  }
}));

const PageFooter = () => {
  const classes = blockStyles();

  return (
    <div className={classes.root}>
      {/* <Link to={Routes.mandatoryInformation()} className={classes.link} >
        {I18n.t("shared.mandatory_information")}
      </Link> */}
      <div className={classes.footerWrapper}>
        <footer className={classes.footer}>
          <div className={classes.footerColumn}>
            <span className={classes.footerTitle}>{I18n.t("shared.xavin")}</span>
            <a href="https://www.xavin.eu/anleger" className={classes.link}>
            {I18n.t("shared.for_investors")}
            </a>
            <a href="https://www.xavin.eu/traeger" className={classes.link}>
              {I18n.t("shared.social_organizations")}
            </a>
            <a
              href="https://www.xavin.eu/finanzierung-anfragen"
              className={classes.link}
            >
              {I18n.t("shared.financial_questions")}
            </a>
            <a
              href="https://www.xavin.eu/blog"
              target="_blank"
              className={classes.link}
            >
              {I18n.t("shared.blog")}
            </a>
          </div>
          <div className={classes.footerColumn}>
            <span className={classes.footerTitle}>{I18n.t("shared.help")}</span>
            <a href="https://www.xavin.eu/p/fragen" className={classes.link}>
              {I18n.t("shared.faq")}
            </a>
            <a href="https://www.xavin.eu/ueber-uns" className={classes.link}>
              {I18n.t("shared.about_us")}
            </a>
            <Link to={Routes.contacts()} className={classes.link}>
              {I18n.t("shared.contacts")}
            </Link>
          </div>
          <div className={classes.footerColumn}>
            <span className={classes.footerTitle}>{I18n.t("shared.rights")}</span>
            <Link
              target={"_blank"}
              to={Routes.termsAndConditions()}
              className={classes.link}
            >
              {I18n.t("shared.terms_and_conditions")}
            </Link>
            <Link to={Routes.riskWarning()} className={classes.link}>
              {I18n.t("shared.risk_warning")}
              <br />
            </Link>
            <Link
              to={Routes.dataProtection()}
              target="_blank"
              className={classes.link}
            >
              {I18n.t("shared.data_protection")}
            </Link>
            <Link to={Routes.imprint()} className={classes.link}>
              {I18n.t("shared.imprint")}
            </Link>
          </div>
        </footer>
        <div className={ clsx(classes.contentLg, classes.borderT, classes.borderBase200, classes.opacity10) } />
        <footer className={classes.footer}>
          <div
            className={clsx(
              classes.footerColumn,
              classes.itemsCenter,
              classes.gridFlowCol
            )}
          >
            <img
              className={clsx(classes.img, classes.desktop)}
              src={XavinLogo}
            />
            <p className={classes.textSm}>
              {I18n.t("shared.copyright")}
              <br />
              {I18n.t("shared.copyright2")}
            </p>
          </div>
          <div
            className={clsx(classes.placeSelfCenter, classes.justifySelfEnd)}
          >
            <div
              className={clsx(
                classes.grid,
                classes.gridFlowCol,
                classes.Gap4,
                classes.text2xl,
                classes.placeSelfCenter,
                classes.justifySelfEnd
              )}
            >
              <a target="_blank" href="https://www.xing.com/pages/xavingmbh">
                <FontAwesomeIcon className={classes.brand} icon="fa-brands fa-xing" />
              </a>
              <a target="_blank" href="https://de.linkedin.com/company/xavin-gmbh">
                <FontAwesomeIcon className={classes.brand} icon="fa-brands fa-linkedin-in" />
              </a>
              <a target="_blank" href="https://www.youtube.com/channel/UCTL4tZDvF9xF7trB-fhGnVQ">
                <FontAwesomeIcon className={classes.brand} icon="fa-brands fa-youtube" />
              </a>
              <a target="_blank" href="https://de-de.facebook.com/xavin.eu/">
                <FontAwesomeIcon className={classes.brand} icon="fa-brands fa-facebook-f" />
              </a>
              <a target="_blank" href="https://www.instagram.com/xavin.eu/">
                <FontAwesomeIcon className={classes.brand} icon="fa-brands fa-instagram" />
              </a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default PageFooter;
